import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { Forecast } from '../models/forecast.model';
import { environment } from '../../environments/environment';

export interface CreateForecastDto {
  employeeId: string;
  designationId?: string;
  categoryId?: string;
  year: number;
  janProjectId?: string;
  janStatus?: number;
  febProjectId?: string;
  febStatus?: number;
  marProjectId?: string;
  marStatus?: number;
  aprProjectId?: string;
  aprStatus?: number;
  mayProjectId?: string;
  mayStatus?: number;
  junProjectId?: string;
  junStatus?: number;
  julProjectId?: string;
  julStatus?: number;
  augProjectId?: string;
  augStatus?: number;
  sepProjectId?: string;
  sepStatus?: number;
  octProjectId?: string;
  octStatus?: number;
  novProjectId?: string;
  novStatus?: number;
  decProjectId?: string;
  decStatus?: number;
}

export interface ForecastCopyResult {
  sourceYear: number;
  targetYear: number;
  sourceCount: number;
  insertedCount: number;
  skippedCount: number;
}

@Injectable({
  providedIn: 'root'
})
export class ForecastService {
  private apiUrl = `${environment.apiUrl}/Forecast`;

  constructor(private http: HttpClient) { }

  getAllForecasts(): Observable<Forecast[]> {
    return this.http.get<Forecast[]>(this.apiUrl).pipe(retry(2));
  }

  getForecastsByYear(year: number): Observable<Forecast[]> {
    return this.http.get<Forecast[]>(`${this.apiUrl}/${year}`).pipe(retry(2));
  }

  addForecast(forecast: Forecast): Observable<Forecast> {
    const createDto: CreateForecastDto = {
      employeeId: forecast.employeeId,
      designationId: forecast.designationId,
      categoryId: forecast.categoryId,
      year: forecast.year,
      janProjectId: forecast.janProjectId,
      janStatus: forecast.janStatus,
      febProjectId: forecast.febProjectId,
      febStatus: forecast.febStatus,
      marProjectId: forecast.marProjectId,
      marStatus: forecast.marStatus,
      aprProjectId: forecast.aprProjectId,
      aprStatus: forecast.aprStatus,
      mayProjectId: forecast.mayProjectId,
      mayStatus: forecast.mayStatus,
      junProjectId: forecast.junProjectId,
      junStatus: forecast.junStatus,
      julProjectId: forecast.julProjectId,
      julStatus: forecast.julStatus,
      augProjectId: forecast.augProjectId,
      augStatus: forecast.augStatus,
      sepProjectId: forecast.sepProjectId,
      sepStatus: forecast.sepStatus,
      octProjectId: forecast.octProjectId,
      octStatus: forecast.octStatus,
      novProjectId: forecast.novProjectId,
      novStatus: forecast.novStatus,
      decProjectId: forecast.decProjectId,
      decStatus: forecast.decStatus
    };
    return this.http.post<Forecast>(this.apiUrl, createDto);
  }

  updateForecast(id: string, forecast: Forecast): Observable<Forecast> {
    return this.http.put<Forecast>(`${this.apiUrl}/${id}`, forecast);
  }

  deleteForecast(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  exportToExcel(year: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/export-excel/${year}`, {
      responseType: 'blob'
    }).pipe(retry(2));
  }

  copyToNextYear(year: number): Observable<ForecastCopyResult> {
    return this.http.post<ForecastCopyResult>(`${this.apiUrl}/copy-to-next-year/${year}`, {});
  }

}


